import { render, staticRenderFns } from "./CustomCrumbBar.vue?vue&type=template&id=64a571b7&"
import script from "./CustomCrumbBar.vue?vue&type=script&lang=js&"
export * from "./CustomCrumbBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports